// extracted by mini-css-extract-plugin
export default {"textInputBox":"TextArea_textInputBox__zU3FQ","inputMain":"TextArea_inputMain__8e9we","iconSize":"TextArea_iconSize__doGMe","hide":"TextArea_hide__I0ihb"};